import { toBanglaString } from "../utils";

function convertTime(date) {
  if (!checkDate(date)) return "০০:০০";

  const dateString = date
    .toLocaleTimeString("en", {
      hour12: true,
      hour: "2-digit",
      minute: "2-digit",
    })
    .replace(/am|pm|\s/gi, "");

  return toBanglaString(dateString);
}

function deduct(date, seconds = 0, minutes = 0) {
  const newDate = new Date(date);
  newDate.setSeconds(newDate.getSeconds() + seconds);
  newDate.setMinutes(newDate.getMinutes() + minutes);
  return newDate;
}

function checkDate(d) {
  const date = new Date(d);
  return date instanceof Date && !isNaN(date);
}

function jumaCheck(date) {
  const today = new Date(date);
  return today.getDay() === 5 ? "জুমা" : "জোহর";
}

class Place {
  constructor(place) {
    this.name = place.name;
    this.bnName = place.bnName;
    this.sehri = place.sehri;
    this.iftar = place.iftar;
  }
}

class Times {
  constructor(times) {
    this.times = times;
    this.date = new Date(times.date);
    this.sehri = new Date(times.sehri);
    this.sunrise = new Date(times.sunrise);
    this.fajr = new Date(times.fajr);
    this.dhuhr = new Date(times.dhuhr);
    this.asr = new Date(times.asr);
    this.maghrib = new Date(times.maghrib);
    this.isha = new Date(times.isha);
    this.prevIsha = new Date(times.yesterday_isha);
    this.tomorrowFajr = new Date(times.tomorrow_fajr);
    this.tomorrowSehri = new Date(times.tomorrow_sehri);
    this.tomorrowSunrise = new Date(times.tomorrow_sunrise);
    this.tomorrowMagrib = new Date(times.tomorrow_maghrib);
  }

  get valids() {
    return Object.values(this.times).every(checkDate);
  }
}

class Prayer {
  constructor(times, place = {}) {
    this.place = place;
    this.times = times;
  }

  setPlace(place) {
    this.place = place;
  }

  get sehri() {
    return deduct(this.times.sehri, 0, this.place.sehri);
  }

  get fajr() {
    return deduct(this.times.fajr, 0, this.place.sehri);
  }

  get sunrise() {
    return deduct(this.times.sunrise, 0, this.place.sehri);
  }

  get dhuhr() {
    return deduct(this.times.dhuhr, 0, this.place.sehri);
  }

  get asr() {
    return deduct(this.times.asr, 0, this.place.sehri);
  }

  get maghrib() {
    return deduct(this.times.maghrib, 0, this.place.iftar);
  }

  get isha() {
    return deduct(this.times.isha, 0, this.place.iftar);
  }

  get prevIsha() {
    return deduct(this.times.prevIsha, 0, this.place.iftar);
  }

  get nextFajr() {
    return deduct(this.times.tomorrowFajr, 0, this.place.sehri);
  }

  get nextSehri() {
    return deduct(this.times.tomorrowSehri, 0, this.place.sehri);
  }

  get nextSunrise() {
    return deduct(this.times.tomorrowSunrise, 0, this.place.sehri);
  }

  get nextMagrib() {
    return deduct(this.times.tomorrowMagrib, 0, this.place.iftar);
  }

  get currentSunrise() {
    const date = new Date();
    const next = date > this.dhuhr;

    return {
      time: next ? convertTime(this.nextSunrise) : convertTime(this.sunrise),
      text: `${next ? "আগামীকাল " : ""}সূর্যোদয়`,
    };
  }

  get currentSehri() {
    const date = new Date();
    const next = date > this.dhuhr;

    return {
      time: next ? convertTime(this.nextSehri) : convertTime(this.sehri),
      text: "সাহ্‌রি শেষ",
    };
  }

  get currentIftar() {
    const date = new Date();
    const next = date > this.isha;

    return {
      time: next ? convertTime(this.nextMagrib) : convertTime(this.maghrib),
      text: "ইফতার শুরু",
    };
  }

  get activePrayer() {
    const date = new Date();

    const fajr = this.fajr;
    const nextFajr = this.nextFajr;
    const dhuhr = this.dhuhr;
    const asr = this.asr;
    const maghrib = this.maghrib;
    const isha = this.isha;

    if (date >= fajr && date < dhuhr) {
      const name = jumaCheck(date);

      return {
        index: 1,
        name,
        startText: `দুপুর ${convertTime(dhuhr)}`,
        startTime: fajr,
        endTime: dhuhr,
      };
    } else if (date >= dhuhr && date < asr) {
      return {
        index: 2,
        name: "আসর",
        startText: `বিকাল ${convertTime(this.asr)}`,
        startTime: dhuhr,
        endTime: asr,
      };
    } else if (date >= asr && date < maghrib) {
      return {
        index: 3,
        name: "মাগরিব",
        startText: `সন্ধ্যা ${convertTime(maghrib)}`,
        startTime: asr,
        endTime: maghrib,
      };
    } else if (date >= maghrib && date < isha) {
      return {
        index: 4,
        name: "এশা",
        startText: `রাত ${convertTime(this.isha)}`,
        startTime: maghrib,
        endTime: deduct(isha),
      };
    } else if (date < fajr || (date >= isha && date < nextFajr)) {
      const today = date < fajr;

      return {
        index: 5,
        name: "ফজর",
        startText: `ভোর ${convertTime(today ? fajr : nextFajr)}`,
        startTime: today ? this.prevIsha : isha,
        endTime: today ? fajr : nextFajr,
      };
    }
  }
}

export { Place, Times, Prayer, convertTime, jumaCheck };
